import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import axios from 'axios'
import { get } from 'lodash'
import mixpanel from '../../utilities/mixpanel'

import ApplicationLayout from '../leevo_ui/ApplicationLayout/ApplicationLayout'
import LoadingSpinner from '../leevo_ui/LoadingSpinner/LoadingSpinner'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs'
import StudentDashboard from './StudentDashboard/StudentDashboard'
import { requestCreator } from '../../utilities/requests'

const { get: getStudents, cancel: cancelStudentsRequests } = requestCreator()

function GuardiansStudentsIndex() {
  const history = useHistory()
  const { guardian_id: GuardianId } = useParams()
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)

  useEffect(() => {
    mixpanel.track('Viewed student dashboard')

    getStudents(`/api/guardians/${GuardianId}/students`, {
      params: {
        include: 'current_skill_level,students_skills,klass_packages',
        all: true
      }
    })
      .then((students) => {
        setStudents(students)
        if (students.length > 0) {
          setSelectedStudent(students[0].id.toString())
        }
        setIsFetchingData(false)
      })
      .catch((error) => {
        const status = get(error, 'response.status')
        if (axios.isCancel(error)) {
          return
        } else if (status === 401) {
          history.push('/')
        } else {
          history.replace('/404')
        }
      })

    return cancelStudentsRequests
  }, [GuardianId, history])

  if (isFetchingData) {
    return (
      <ApplicationLayout>
        <LoadingSpinner className="flex items-center justify-center my-10" />
      </ApplicationLayout>
    )
  }

  if (students.length === 0) {
    return (
      <ApplicationLayout>
        <div className="flex flex-col items-center justify-center py-12">
          <p className="text-lg text-gray-600">No students found.</p>
        </div>
      </ApplicationLayout>
    )
  }

  return (
    <ApplicationLayout>
      <div className="max-w-6xl mx-auto px-3 py-6">
        {students.length === 1 ? (
          <StudentDashboard student={students[0]} />
        ) : (
          <Tabs value={selectedStudent} onValueChange={setSelectedStudent} className="w-full">
            <TabsList className="w-full justify-start mb-6 h-auto flex-wrap gap-2 bg-white border border-gray-200 p-2">
              {students.map((student) => (
                <TabsTrigger
                  key={student.id}
                  value={student.id.toString()}
                  className="data-[state=active]:bg-purple-600 data-[state=active]:text-white"
                >
                  {student.fullName}
                </TabsTrigger>
              ))}
            </TabsList>

            {students.map((student) => (
              <TabsContent key={student.id} value={student.id.toString()}>
                <StudentDashboard student={student} />
              </TabsContent>
            ))}
          </Tabs>
        )}
      </div>
    </ApplicationLayout>
  )
}

export default GuardiansStudentsIndex
